import React from 'react';
import { Modal } from 'react-bootstrap';

interface StandardBootstrapModalPropsI {
  headerText?: string;
  bodyData?: React.ReactNode;
  footerData?: React.ReactNode;
  show: boolean;
  onClose: () => void;
  size?: 'sm' | 'lg' | 'xl';
  scrollable?: boolean;
  dialogClassName?: string;
}

const StandardBootstrapModal = (props: StandardBootstrapModalPropsI) => {
  return (
    <Modal
      centered
      backdrop="static"
      show={props.show}
      onHide={props.onClose}
      size={props.size}
      scrollable={props.scrollable}
      dialogClassName={props.dialogClassName}
    >
      <Modal.Header closeButton className="fw-bolder fs-6">
        {props.headerText}
      </Modal.Header>
      <Modal.Body>{props.bodyData}</Modal.Body>
      {props.footerData && <Modal.Footer>{props.footerData}</Modal.Footer>}
    </Modal>
  );
};

export default StandardBootstrapModal;
